// extracted by mini-css-extract-plugin
export default {"root":"StudioControls-root_mFm4m","studioControls":"StudioControls-studioControls_i8JVS","logo":"StudioControls-logo_JxlaE","stepper":"StudioControls-stepper_TEDxU"};